import { render, staticRenderFns } from "./bilgilerim.vue?vue&type=template&id=25b85cac"
import script from "./bilgilerim.vue?vue&type=script&lang=js"
export * from "./bilgilerim.vue?vue&type=script&lang=js"
import style0 from "./bilgilerim.vue?vue&type=style&index=0&id=25b85cac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports